import React, { useState } from "react";
import Drawer from "../../../../drawer/Drawer";
import ManagePlanProduct from "./ManagePlanProduct";

const PlanProductManageDrawer = ({
  open,
  close = () => {},
  getResponse = () => {},
  data = {},
}) => {
  return (
    <Drawer
      open={open}
      onClose={(val) => {
        close(val);
      }}
      actualSize={"xl"}
      size={"xl3"}
      title={data?._id ? "Update Plan Product" : "Add Plan Product"}
      subtitle=""
      drawerBodyclassName="p-0 max-h-[calc(100%-90px)]"
    >
      <div className="h-full overflow-y-auto">
        <ManagePlanProduct
          getResponse={getResponse}
          close={close}
          data={data}
        />
      </div>
    </Drawer>
  );
};

export default PlanProductManageDrawer;
